import {doc} from '../docs.js';
import * as THREE from "three";
import ZShaderMaterial from "../../custom/ZShaderMaterial.js";

doc(
    "three.shaderMaterial",
    {
    },
    "Creates a material out of shaders",
    () => 0,
    {
        tags: "Graphics",
        inlets: 0,
        connects: {
            object: "three.mesh",
            inlet: "1"
        }
    });

const shaderMaterial = (object) => {
    let zshader = new ZShaderMaterial(object);
    object.effect = zshader;

    return () => {
    };
};


doc(
    "three.basicMaterial",
    {
        "color": "",
        "wireframe": ""
    },
    "Creates a basic material with color in 2nd inlet",
    undefined,
    {
        tags: "Graphics",
        isHot: true,
        inlets: 2,
        connects: {
            object: "three.mesh",
            inlet: "1"
        }
    });

const basicMaterial = (object, wireframe) => {
    let material = new THREE.MeshBasicMaterial( {
        color: 0xffffff, wireframe:false, blending: THREE.AdditiveBlending } );
    material.side = THREE.DoubleSide;
    material.needsUpdate = true;

    return ([color]) => {
        if (color && typeof color === "string") {
            color = new THREE.Color(color);
        }
        material.color = color || 0xffffff;
        material.side = THREE.DoubleSide;
        material.wireframe = wireframe() ? true : false;
        material.needsUpdate = true;
        return [material];
        
    };
};

doc(
    "three.vertexColorsMaterial",
    {
        "color": "",
        "wireframe": ""
    },
    "Creates a basic material with color in 2nd inlet",
    undefined,
    {
        tags: "Graphics",
        isHot: true,
        inlets: 2,
        connects: {
            object: "three.mesh",
            inlet: "1"
        }
    });

const vertexColorsMaterial = (object, wireframe) => {
    let material = new THREE.MeshBasicMaterial( {
        vertexColors: true, wireframe:false, blending: THREE.AdditiveBlending } );
    material.side = THREE.DoubleSide;
    material.needsUpdate = true;

    return ([color]) => {
        if (color && typeof color === "string") {
            color = new THREE.Color(color);
        }
        material.color = color || 0xffffff;
        material.side = THREE.DoubleSide;
        material.wireframe = wireframe() ? true : false;
        material.needsUpdate = true;
        return [material];
        
    };
};

doc(
    "three.setVertexColors",
    {
        "color": "",
        "wireframe": ""
    },
    "Creates a basic material with color in 2nd inlet",
    undefined,
    {
        tags: "Graphics",
        isHot: true,
        inlets: 2,
        connects: {
            object: "three.mesh",
            inlet: "1"
        }
    });

const setVertexColors = (object, inputColors) => {
    return ([geometry]) => {
        const positionAttribute = geometry.getAttribute( 'position' );
        
        let _input = inputColors() || [];
        const colors = [];
        const color = new THREE.Color();
        
        for ( let i = 0; i < positionAttribute.count; i += 3 ) {
            
            color.set(_input[i%_input.length] || Math.random() * 0xffffff );
            
            // define the same color for each vertex of a triangle
            
            colors.push( color.r, color.g, color.b );
            colors.push( color.r, color.g, color.b );
            colors.push( color.r, color.g, color.b );
            
        }
        
        // define the new attribute
        
        geometry.setAttribute( 'color', new THREE.Float32BufferAttribute( colors, 3 ) );

        return [geometry];
        
    };
};




doc(
    "three.pointsMaterial",
    {
        "color": "",
    },
    "Creates a basic material with color in 2nd inlet",
    undefined,
    {
        tags: "Graphics",
        inlets: 1,
    });

const pointsMaterial = (object, wireframe) => {
    let material = new THREE.PointsMaterial({ color: 0xffffff, blending: THREE.AdditiveBlending } );
    material.needsUpdate = true;

    return ([color]) => {
        if (color && typeof color === "string") {
            color = new THREE.Color(color);
        }
        material.color = color || 0xffffff;
        material.needsUpdate = true;
        return [material];
        
    };
}




export const materials = {
    "three.vertexColorsMaterial": vertexColorsMaterial,
    "three.setVertexColors": setVertexColors,
    "three.pointsMaterial": pointsMaterial,
    "three.basicMaterial": basicMaterial,
    "three.shaderMaterial": shaderMaterial,
};
